/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestPagedList } from '../../models/export-request-paged-list';
import { SortDirection } from '../../models/sort-direction';

export interface GetChildOfRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the export request's name
 *   * CREATION_DATE : the export request's creation date
 *   * FREQUENCY : the export request's frequency
 *   * STATE : the export request's state
 */
  sortFieldName?: 'NAME' | 'CREATION_DATE' | 'FREQUENCY' | 'STATE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
}

export function getChildOfRequest(http: HttpClient, rootUrl: string, params: GetChildOfRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestPagedList>> {
  const rb = new RequestBuilder(rootUrl, getChildOfRequest.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestPagedList>;
    })
  );
}

getChildOfRequest.PATH = '/export-request/{uid}/children';
